import { render } from "./AdicionarCartaoClinica.vue?vue&type=template&id=37116ab2&scoped=true"
import script from "./AdicionarCartaoClinica.vue?vue&type=script&lang=js"
export * from "./AdicionarCartaoClinica.vue?vue&type=script&lang=js"

import "./AdicionarCartaoClinica.vue?vue&type=style&index=0&id=37116ab2&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37116ab2"]])

export default __exports__